<template>
  <div>
    <v-container style="max-width: 750px">
      <div>
        <v-btn
          @click="
            showEdit = true
            edittype = 'create'
          "
          x-large
          large
          block
          outline
          color="green"
        >
          <span class="fas fa-plus mr-2"></span> Add category
        </v-btn>
      </div>
      <div>
        <v-card v-for="item in category" :key="item.id">
          <v-layout row wrap>
            <v-flex xs3 class="pa-1">
              <div style="background-color: #eee; width: 130px; height: 130px">
                <v-img height="130px" width="130px" contain :src="item.photourl"></v-img>
              </div>
            </v-flex>
            <v-flex @click="expandThis(item.id)" style="position: relative" xs9>
              <div style="position: absolute; right: 5px; top: 5px" class="text-xs-right">
                <v-btn
                  depressed
                  color="grey"
                  icon
                  @click.stop="
                    edittype = 'edit'
                    editdata = item
                    showEdit = true
                  "
                >
                  <v-icon color="white">edit</v-icon>
                </v-btn>
                <v-btn depressed color="grey" @click.stop="deleteCategory(item)" icon>
                  <v-icon color="white">delete</v-icon>
                </v-btn>
              </div>
              <div class="pt-5">
                <p class="title">{{ item.name }}</p>
              </div>

              <div
                class="text-xs-center"
                style="position: absolute; bottom: 5px; left: 50%; transform: translateX(-50%)"
              >
                <v-icon v-if="isExpand(item.id)">expand_less</v-icon>
                <v-icon v-else>expand_more</v-icon>
              </div>
            </v-flex>
            <v-flex xs12 v-if="isExpand(item.id)">
              <div class="pa-2">
                <ServiceByCategory :category_id="item.id"></ServiceByCategory>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
    </v-container>
    <v-dialog v-model="showEdit" persistent width="750">
      <EditServiceCategory
        v-if="showEdit"
        @close="showEdit = false"
        @oncreate="onCreateCategory"
        @onedit="onEditCategory"
        :edittype="edittype"
        :editdata="editdata"
      ></EditServiceCategory>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import EditServiceCategory from './EditServiceCategory.vue'
import EditService from './EditService.vue'
import Products from './Products.vue'
import ServiceByCategory from './ServiceByCategory.vue'

import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getCategory()
  },
  components: {
    EditServiceCategory,
    Products,
    EditService,
    ServiceByCategory
  },
  data() {
    return {
      loadingproduct: true,
      expanded: [],
      showProduct: false,
      showEdit: false,
      edittype: '',
      editdata: {},
      category: [],
      showEditProduct: false,
      editproducttype: '',
      editproductdata: {},
      category: [],
      allservices: []
    }
  },
  methods: {
    showProductCreate(item) {
      this.editproducttype = 'create'
      this.editproductdata = { category_id: item.id }
      this.showEditProduct = true
    },
    onCreateCategory(item) {
      this.category.push(item)
      this.showEdit = false
    },
    onEditCategory(item) {
      var index = this.category.findIndex((el) => el.id == item.id)
      this.$set(this.category, index, item)
      this.showEdit = false

      this.getCategory()
    },

    expandThis(id) {
      var index = this.expanded.findIndex((el) => el == id)
      if (index == -1) {
        this.expanded.push(id)
      } else {
        this.expanded.splice(index, 1)
      }
      this.$forceUpdate()
    },
    isExpand(id) {
      var index = this.expanded.findIndex((el) => el == id)
      if (index == -1) return false
      else return true
    },
    deleteCategory(item) {
      this.$swal
        .fire({
          type: 'question',
          text: 'ต้องการลบใช่หรือไม่?',
          showCancelButton: true
          // reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.$store.state.loading = true
            api.deletemjdservicescategory(
              { pageid: this.selectedBot.pageid, category_id: item.id },
              (err, response) => {
                this.$store.state.loading = false
                if (response.responsecode == 200) {
                  this.category.splice(
                    this.category.findIndex((el) => el.id == item.id),
                    1
                  )
                }
              }
            )
          }
        })
    },

    getCategory() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve) => {
        this.$store.state.loading = true
        api.getmjdservicescategory(data, (err, response) => {
          this.$store.state.loading = false
          if (response.responsecode == 200) {
            this.category = response.data
          } else {
            this.category = []
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/Service.vue